export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '完全成功報酬制',
      description: '着手金・月額費用は一切不要。成約時のみ報酬をいただく安心の料金体系です。',
      gradient: 'from-teal-500 to-cyan-500'
    },
    {
      icon: 'ri-team-line',
      title: '豊富な実績',
      description: '1,200件以上の成約実績。様々な業種・規模のM&Aをサポートしてきました。',
      gradient: 'from-blue-500 to-indigo-500'
    },
    {
      icon: 'ri-user-star-line',
      title: '専門家チーム',
      description: '公認会計士、税理士、弁護士など各分野の専門家が連携してサポートします。',
      gradient: 'from-violet-500 to-purple-500'
    },
    {
      icon: 'ri-lock-2-line',
      title: '秘密厳守',
      description: '厳格な情報管理体制のもと、機密情報を確実に保護いたします。',
      gradient: 'from-fuchsia-500 to-pink-500'
    },
    {
      icon: 'ri-time-line',
      title: 'スピード対応',
      description: '豊富なネットワークを活用し、迅速なマッチングを実現します。',
      gradient: 'from-orange-500 to-amber-500'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '手厚いサポート',
      description: '初回相談から成約後まで、専任担当者が一貫してサポートいたします。',
      gradient: 'from-emerald-500 to-teal-500'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-slate-50 to-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-30">
        <div className="absolute top-20 right-20 w-96 h-96 bg-teal-200 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-cyan-200 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <span className="text-teal-600 font-bold text-sm tracking-widest uppercase mb-4 block">
            Why Choose Us
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            選ばれる理由
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            最先端のテクノロジーと豊富な経験で、最高のM&A体験を提供します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-transparent hover:-translate-y-2"
            >
              {/* Gradient Border on Hover */}
              <div className={`absolute inset-0 rounded-3xl bg-gradient-to-br ${feature.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10 blur-xl`}></div>
              
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-black text-gray-900 mb-4">
                {feature.title}
              </h3>
              
              <p className="text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>

              {/* Decorative Element */}
              <div className={`absolute bottom-0 right-0 w-24 h-24 bg-gradient-to-br ${feature.gradient} opacity-5 rounded-tl-full transition-all duration-500 group-hover:opacity-10`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
